import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Dashboard from "./Pages/Dashboard/Dashboard"
import Login from "./Pages/NewSignup/Login"
import Verification from "./Pages/Verificationpage/Verification"
import Reset from "./Pages/Resetpage/Reset"
import Success from "./Pages/Successfulpage/Success"
import Welly from "./Pages/Welly/Welly"
import Fill from "./Pages/Fill/Fill"
import Process from "./Pages/Process/Process"
import Signnew from "./Pages/Signnew/signnew.js";

import Layout from "./Components/Layout";

// import Signup from "./Pages/Signup/Signup";
import Signup from "./Pages/NewSignup/Signup";
import Create from "./Pages/Create/Create";
import Request from "./Pages/Request/Request";
import Budget from "./Pages/Budget/BudgetPerformance";
import Settings from "./Pages/Settings/Profilesettings";
import Account from "./Pages/Account/Account";
import Application from "./Pages/Application/Pay.js";
import Welcome from "./Pages/NewSignup/Welcome";
import ForgotPassword from "./Pages/NewSignup/ForgotPassword";
import ForgotEmailVerify from "./Pages/NewSignup/ForgotEmailVerify";
import { ThemeProvider } from './ThemeContext.js';
import GlobalStyles from './GlobalStyles.js';
import Reports from "./Pages/New Reports/Reports.js";
import FrequentQuestion from "./Pages/FAQs/FrequentQuestion.js";
import MyAccount from "./Pages/My Account/MyAccount.js";
import Settingss from "./Pages/New Settings/Settingss.js";
import AllApplications from "./Pages/All Applications/AllApplications.js";
import Allinvoices from "./Pages/All Invoices/Allinvoices.js";
import AllPayment from "./Pages/All Payments/AllPayment.js";
import NewApplications from "./Pages/New Applicationss/NewApplications.js";
import LandRatificationApp from "./Pages/New Applicationss/LandRatificationApplication.js";
import OnboardingCompleteReg from "./Pages/NewSignup/OnboardingCompleteReg.js";
import FinishOnboarding from "./Pages/Finish Onboarding/FinishOnboarding.js";
import NewNinVerification from "./Pages/NewSignup/NewNinVerification.js";
import OnboardingStin from "./Pages/NewSignup/OnboardingStin.js";
import CompletedSuccess from "./Pages/NewSignup/CompletedSuccess.js";
import NewCacCompleteReg from "./Pages/CAC Complete Reg/NewCacCompleteReg.js";
import ApplicationPage from "./Pages/ApplicationPage/Application.js";
// import InvoiceNew from "./Pages/All Invoices/InvoiceNew.js";
// import ReceiptNew from "./Pages/ReceiptNew.js";
import Invoices from "./Pages/Invoices/Invoices.js";
import Landing from "./Pages/LandingPage/Landing.js";


import Docs from "./Pages/Docs/Docs.js"
import Lognew from "./Pages/Lognew/Lognew.js"
import Newsign from "./Pages/Newsign/Newsign.js";
import Invoice1 from "./Pages/Invoices/Invoice1.js";
import InvoiceNew from "./Pages/All Invoices/Invoices.js";
import ReceiptsNew from "./Pages/All Invoices/Receipt.js";
import GenerateBill from "./Pages/All Invoices/GenerateBill.js";
import Pay from "./Pages/Application/Pay.js";
import SignupInvoice from "./Pages/All Invoices/SignupInvoice.js";
import BillDetail from "./Pages/All Invoices/InvoiceDetail.js";
import MeterApplication from "./Pages/All Payments/MeterApplication.js";
import LandingHome from "./Pages/NewLanding/LandingHome.js";
import MeterInvoice from "./Pages/All Invoices/MeterInvoice.js";
// import LandCore from "./Pages/LandingPage/LandCore.js";
import NewLogin from "./Pages/Lognew/NewLogin.js";
import NewSignup from "./Pages/Lognew/NewSignup.js";
function App() {
  return (
    <ThemeProvider>
      <GlobalStyles>
        <Router>
          <Routes>
            {/* Routes that include the Sidebar */}
            <Route path="/" element={<LandingHome />} />
            <Route path="/home" element={<Dashboard />} />
            <Route
              path="/request" element={<Request />} />
            <Route path="/budget-performance" element={<Layout> <Budget /> </Layout>} />
            <Route
              path="/profile-settings"
              element={
                <Layout>
                  <Settings />
                </Layout>
              }
            />

            {/* Routes without Sidebar (Login, Signup, Account) */}
            {/* <Route path="/signup" element={<Signup />} /> */}
            {/* <Route path="/create" element={<Create />} /> */}
            {/* <Route path="/" element={<Welcome />} /> */}
            <Route path="/signup" element={<NewSignup />} />
            <Route path="/login" element={<NewLogin />} />
            <Route path="/print_invoices" element={<Invoice1 />} />
            <Route path="/account" element={<Account />} />
            <Route path="/complete_your_registration" element={<OnboardingCompleteReg />} />
            {/* <Route path="/finish_onboarding_process" element={<FinishOnboarding />} /> */}
            <Route path="/nin_verificaation" element={<NewNinVerification />} />
            <Route path="/complete_your_registration_stin" element={<OnboardingStin />} />
            <Route path="/completed_registration_successful" element={<CompletedSuccess />} />
            <Route path="/generated_invoice" element={<Invoices />} />
            <Route path="/complete_your_registration_cac" element={<NewCacCompleteReg />} />
            <Route path="/pay" element={<Pay />} />
            {/* <Route path="/login" element={<Login />} /> */}
            <Route path="/forgot_password" element={<ForgotPassword />} />
            <Route path="/verify_otp" element={<ForgotEmailVerify />} />
            <Route path="/verification" element={<Verification />} />
            <Route path="/reset" element={<Reset />} />
            <Route path="/success" element={<Success />} />
            <Route path='/settings' element={<MyAccount />} />
            <Route path='/services' element={<AllApplications />} />
            <Route path="/customer_support" element={<Reports />} />
            <Route path="/faqs" element={<FrequentQuestion />} />
            <Route path="/my_account" element={<MyAccount />} />
            <Route path="/invoices" element={<Allinvoices />} />
            <Route path="/invoice_detail" element={<BillDetail />} />
            <Route path="/meter_application_invoice" element={<MeterInvoice />} />
            {/* <Route path="/view_invoices" element={<InvoiceNew />} /> */}
            {/* <Route path="/view_receipts" element={<ReceiptNew />} /> */}
            <Route path="/view_invoices" element={<InvoiceNew />} />
            <Route path="/signup_invoice" element={<SignupInvoice />} />
            <Route path="/view_receipts" element={<ReceiptsNew />} />
            <Route path="/generate_bill" element={<GenerateBill />} />
            <Route path="/payments" element={<AllPayment />} />
            <Route path="/meter_application" element={<MeterApplication />} />
            <Route path='/new_applications' element={<NewApplications />} />
            <Route path='/applications_building_permit' element={<LandRatificationApp />} />
            <Route path='/application_page' element={<ApplicationPage />} />
            <Route path='/signnew' element={<Signnew />} />
            <Route path="/Welly" element={<Welly />} />
            <Route path="/Fill" element={<Fill />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/finish_onboarding_process" element={<FinishOnboarding />} />
            
             {/* <Route path="/lognew" element={<Lognew />} />
            <Route path="/newsign" element={<Newsign />} /> */}
          </Routes>
        </Router>
      </GlobalStyles>
    </ThemeProvider>
  );
}

export default App;
